import { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import MicrositeRoutes from "../routes/eu-combo-routes";
import SvgIcons from "../components/re-usable/icons/svg-icons";
import { useAppDispatch } from "../redux/store";
import { retrieveNotification } from "../redux/slice/notification-slice";
import LoadingComp from "../components/re-usable/loading/loading";
import EUComboHeader from "../components/header/eu-combo-header";
import EUCRMConferenceLayoutStyleComponent from "./components/eucrm-layout-style.component";

const Layout = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(retrieveNotification())
  })
  return (
    <>
      <EUCRMConferenceLayoutStyleComponent />
      <div>
        <EUComboHeader />
        <Suspense fallback={<LoadingComp />}>
          <Routes>
            {MicrositeRoutes.map((route, index) => {
              return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
            })}
          </Routes>
        </Suspense>
      </div >
    </>
  );
};

export default Layout;